import Highcharts from "highcharts/highstock";
import GKCharts from "./GKCharts";

const GKGaugeChart = ({
  maxValue,
  value,
}: {
  maxValue: number;
  value: number;
}) => {
  return (
    <GKCharts
      chartOptions={{
        chart: {
          type: "gauge",
        },
        title: {
          text: " ",
        },
        pane: {
          startAngle: -90,
          endAngle: 90,
          background: null,
          center: ["50%", "80%"],
          size: "100%",
        },
        yAxis: {
          min: 0,
          max: maxValue,
          tickPixelInterval: 0,
          tickPosition: "inside",
          tickLength: 0,
          tickWidth: 0,
          minorTickInterval: null,
          labels: {
            enabled: false,
            distance: 200,
            style: {
              fontSize: "0px",
            },
          },
          lineWidth: 0,
          plotBands: [
            {
              from: 0,
              to: maxValue / 2,
              color: {
                linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
                stops: [
                  [0, "rgb(100, 240, 1)"],
                  [1, "rgb(239, 240, 1)"],
                ],
              },
              thickness: 25,
            },
            {
              from: maxValue / 2,
              to: maxValue,
              color: {
                linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
                stops: [
                  [0, "rgb(239, 240, 1)"],
                  [1, "rgb(255, 100, 1)"],
                ],
              },
              thickness: 25,
            },
          ],
        },

        series: [
          {
            name: "Points",
            data: [value],
            dataLabels: {
              format: " ",
              borderWidth: 0,
              color:
                (Highcharts.defaultOptions.title &&
                  Highcharts.defaultOptions.title.style &&
                  Highcharts.defaultOptions.title.style.color) ||
                "var(--neutral-500)",
              style: {
                fontSize: "16px",
              },
            },
            dial: {
              radius: "80%",
              backgroundColor: "gray",
              baseWidth: 12,
              baseLength: "0%",
              rearLength: "0%",
            },
            pivot: {
              backgroundColor: "gray",
              radius: 6,
            },
          },
        ],
      }}
      containerProps={{ style: { width: "300px", height: "300px" } }}
    />
  );
};

export default GKGaugeChart;
